"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBookingNotesExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const model_1 = require("./model");
const services_1 = tslib_1.__importDefault(require("../../../services"));
const getById_1 = tslib_1.__importDefault(require("../../saas/bookings/getById"));
const updateBookingNotes = toolkitRaw.createAsyncThunk('bookings/fetch_update_booking_notes', async (data, { rejectWithValue, dispatch }) => {
    try {
        const updatePayload = new model_1.Payload(data.notes);
        if (data.id) {
            await services_1.default.patch('/api/saas/me/bookings/' + data.id, updatePayload.model);
            await dispatch((0, getById_1.default)({ id: data === null || data === void 0 ? void 0 : data.id }));
        }
        return null;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const updateBookingNotesExtraReducers = (builder) => {
    builder.addCase(updateBookingNotes.pending, (state) => {
        state.booking.slices.notes.loading = true;
    });
    builder.addCase(updateBookingNotes.fulfilled, (state) => {
        state.booking.slices.notes.error = false;
        state.booking.slices.notes.loading = false;
    });
    builder.addCase(updateBookingNotes.rejected, (state) => {
        state.booking.slices.notes.error = true;
        state.booking.slices.notes.loading = false;
    });
};
exports.updateBookingNotesExtraReducers = updateBookingNotesExtraReducers;
exports.default = updateBookingNotes;
//# sourceMappingURL=index.js.map